@if (deferHeavyUi()) {
    <p-splitter [panelSizes]="[30, 70]" orientation="horizontal">
        <ng-template pTemplate>
            <!-- min-height is applied here because its not working if applied on p-splitter -->
            <div class="flex flex-col w-full" [style.min-height]="minHeightInPt() + 'pt'">
                <div class="flex items-center content-center gap-1 m-2">
                    <!-- PURCHASE PRICE REFERENCE WARNING OR NORMAL HEADER -->
                    @if (hasPurchasePriceReferenceProduct()) {
                        <!-- Inherited Purchase Prices Header -->
                        <div
                            class="flex items-center gap-2 w-full bg-primary-50 dark:bg-primary-900/20 p-2 rounded-md border border-primary-200 dark:border-primary-800"
                        >
                            <i
                                class="fas fa-link text-primary-600 dark:text-primary-400"
                                [attr.data-testid]="
                                    dataTestid() + '-inherited-purchase-price-reference-header-icon'
                                "
                            ></i>
                            <span
                                class="text-primary-700 dark:text-primary-300 font-medium text-sm"
                                [attr.data-testid]="
                                    dataTestid() + '-inherited-purchase-price-reference-header-span'
                                "
                            >
                                {{ 'product.prices-of' | translate }}
                                <a
                                    class="underline hover:text-primary-800 dark:hover:text-primary-200 transition-colors"
                                    [routerLink]="[
                                        '/products/edit',
                                        purchasePriceReferenceProductId()
                                    ]"
                                    [attr.data-product-id]="purchasePriceReferenceProductId()"
                                    [attr.data-testid]="
                                        dataTestid() +
                                        '-inherited-purchase-price-reference-header-a'
                                    "
                                >
                                    {{ purchasePriceReferenceProductIdentifier() }}
                                </a>
                            </span>
                            <i
                                class="fas fa-external-link-alt text-primary-500 dark:text-primary-400 text-xs ml-auto cursor-pointer hover:text-primary-600 dark:hover:text-primary-300 transition-colors"
                                (click)="openPurchaseRefInNewTab()"
                                pTooltip="common.open-in-new-tab"
                                [attr.data-testid]="
                                    dataTestid() + '-inherited-purchase-price-reference-header-i'
                                "
                            ></i>
                        </div>
                    } @else {
                        <!-- QUANTITY -->
                        <span
                            pTooltip="{{
                                'product.vendor-relationships-list-quantity' | translate
                            }}"
                        >
                            <p-badge
                                [value]="fieldsSig().length"
                                [attr.data-testid]="
                                    dataTestid() + '-vendor-relationships-list-quantity-badge'
                                "
                            ></p-badge>
                        </span>
                        <!-- TITLE -->
                        <h6 [attr.data-testid]="dataTestid() + '-vendor-relationships-list-h6'">
                            {{ 'product.vendor-relation' | translate }}
                        </h6>
                        <!-- ADD -->
                        <p-button
                            size="small"
                            (onClick)="handlePriceList('save')"
                            icon="fa fa-plus"
                            text="true"
                            [pTooltip]="'common.add' | translate"
                            [attr.data-testid]="
                                dataTestid() + '-vendor-relationships-list-add-button'
                            "
                        >
                        </p-button>
                        <!-- EDIT Button, has no real use right now, dont show! -->
                        <!-- @if (priceListLinkNodeSelectedSig()) {
                    <p-button
                        pTooltip="{{ 'price-list.edit' | translate }}"
                        (onClick)="handlePriceList('edit')"
                        icon="fa fa-pencil"
                        text="true"
                    >
                    </p-button>
                } -->
                        <!-- DELETE Button -->
                        @if (priceListLinkNodeSelectedSig()) {
                            <p-button
                                severity="danger"
                                pTooltip="{{ 'price-list.delete' | translate }}"
                                (onClick)="deleteVendorPriceListWithConfirm()"
                                icon="fa fa-trash"
                                text="true"
                                [attr.data-testid]="
                                    dataTestid() + '-vendor-relationships-list-delete-button'
                                "
                            />
                        }
                    }
                </div>
                <hr />
                <!-- LISTBOX ITEMS -->
                @if (isLoadingSig()) {
                    <p-skeleton
                        height="2.5rem"
                        class="flex"
                        styleClass="m-1"
                        [attr.data-testid]="dataTestid() + '-vendor-relationships-list-skeleton'"
                    />
                } @else {
                    <p-listbox
                        #pListbox
                        [options]="fieldsSig()"
                        [(ngModel)]="priceListLinkNodeSelectedSig"
                        [multiple]="false"
                        [metaKeySelection]="true"
                        dataKey="id"
                        [listStyle]="{
                            maxHeight:
                                (fieldsSig().length | calculateListHeight: 40 : 100 : 0.7) + 'px',
                            width: '100%'
                        }"
                        (onChange)="loadItemsOfPriceList()"
                        [styleClass]="
                            fieldsSig()?.length === 0
                                ? 'w-full flex !border-none !shadow-none'
                                : 'w-full flex border-surface-0 dark:border-surface-900'
                        "
                        [striped]="true"
                        [attr.data-testid]="dataTestid() + '-vendor-relationships-list-p-listbox'"
                    >
                        <ng-template let-item #item>
                            <app-price-list-display-row-widget
                                [priceListSig]="item.vendorPriceList"
                                [currentPriceEntrySig]="currentNetPriceEntryFor(item)"
                                [priceTooltip]="
                                    isDiscountedOverviewPrice(item)
                                        ? ('product.discounted-price-tooltip' | translate)
                                        : null
                                "
                                [noDebitorNumber]="true"
                                [addressSig]="item.address"
                                [dataTestid]="
                                    dataTestid() +
                                    '-vendor-relationships-list-price-list-display-row-widget'
                                "
                            />
                        </ng-template>
                    </p-listbox>
                }
            </div>
        </ng-template>
        <ng-template pTemplate #content>
            <ngx-ui-loader #loader [loaderId]="'loader-present-vendor-prices'" />

            <div class="flex flex-col w-full h-full">
                <!-- RIGHT PANEL PURCHASE PRICE REFERENCE HEADER -->
                @if (hasPurchasePriceReferenceProduct()) {
                    <div
                        class="flex items-center gap-2 w-full bg-primary-50 dark:bg-primary-900/20 p-3 m-2 rounded-md border border-primary-200 dark:border-primary-800"
                    >
                        <i
                            class="fas fa-link text-primary-600 dark:text-primary-400"
                            [attr.data-testid]="
                                'formly-product-vendor-product-price-edit-vendor-relationships-list-fas-fa-link'
                            "
                        ></i>
                        <span class="text-primary-700 dark:text-primary-300 font-medium">
                            {{ 'product.prices-of' | translate }}
                            <a
                                class="underline hover:text-primary-800 dark:hover:text-primary-200 transition-colors"
                                [routerLink]="['/products/edit', purchasePriceReferenceProductId()]"
                                [attr.data-product-id]="purchasePriceReferenceProductId()"
                                [attr.data-testid]="
                                    'formly-product-vendor-product-price-edit-vendor-relationships-list-a'
                                "
                            >
                                {{ purchasePriceReferenceProductIdentifier() }}
                            </a>
                        </span>
                        <i
                            class="fas fa-external-link-alt text-primary-500 dark:text-primary-400 text-sm ml-auto cursor-pointer hover:text-primary-600 dark:hover:text-primary-300 transition-colors"
                            (click)="openPurchaseRefInNewTab()"
                            pTooltip="Open in new tab"
                            [attr.data-testid]="
                                'formly-product-vendor-product-price-edit-vendor-relationships-list-fas-fa-external-link-alt'
                            "
                        ></i>
                        <i
                            class="fas fa-info-circle text-primary-600 dark:text-primary-400"
                            pTooltip="{{ 'product.price-reference-info' | translate }}"
                            [attr.data-testid]="
                                'formly-product-vendor-product-price-edit-vendor-relationships-list-fas-fa-info-circle'
                            "
                        ></i>
                    </div>
                }

                @if (!priceListLinkNodeSelectedSig()) {
                    <div
                        class="flex justify-center items-center choose-ngifloader-splitter"
                        style="height: 100%; width: 100%"
                    >
                        <div
                            class="shine"
                            [attr.data-testid]="
                                'formly-product-vendor-product-price-edit-vendor-relationships-list-shine'
                            "
                        >
                            <h3
                                [attr.data-testid]="
                                    'formly-product-vendor-product-price-edit-vendor-relationships-list-h3'
                                "
                            >
                                {{ 'product.vendor-pricelist-choose' | translate }}
                            </h3>
                        </div>
                    </div>
                }
                @if (priceListLinkNodeSelectedSig()?.vendorPriceList) {
                    <div class="w-full">
                        <div>
                            <app-price-list-entry-list-widget
                                #priceListEntryListWidget
                                [product]="product()"
                                [productIdToUse]="product()?.purchasePriceReferenceProductId"
                                [noSort]="true"
                                [listType]="PriceListType.VENDOR"
                                [creditorAddressId]="priceListLinkNodeSelectedSig()?.addressId"
                                [creditorIdentifier]="
                                    priceListLinkNodeSelectedSig()?.address?.creditor?.identifier
                                "
                                [paginator]="false"
                                [priceList]="priceListLinkNodeSelectedSig()?.vendorPriceList"
                                [withBulkPrices]="true"
                                [addInDetail]="false"
                                [onlyActive]="true"
                                [readonly]="hasPurchasePriceReferenceProduct()"
                                [noAddNew]="hasPurchasePriceReferenceProduct()"
                                [noDelete]="hasPurchasePriceReferenceProduct()"
                                [noBaseEdit]="true"
                                [noCopy]="true"
                                [inlineEditMode]="!hasPurchasePriceReferenceProduct()"
                                [hasPriceReferenceProduct]="hasPurchasePriceReferenceProduct()"
                                [dataTestId]="
                                    'formly-product-vendor-product-price-edit-vendor-relationships-list-price-list-entry-list-widget-1'
                                "
                                (onSaved)="onPriceEntrySaved()"
                            />
                        </div>
                        <div class="ms-3 mt-4 mb-2" *ngIf="!hasPurchasePriceReferenceProduct()">
                            <phx-checkbox
                                [(ngModel)]="historyCheckedSig"
                                [label]="'product.price-view-history' | translate"
                                [dataTestId]="
                                    'formly-product-vendor-product-price-edit-vendor-relationships-list-phx-checkbox'
                                "
                            />
                        </div>

                        @if (
                            historyCheckedSig() &&
                            priceListLinkNodeSelectedSig()?.vendorPriceList &&
                            !hasPurchasePriceReferenceProduct()
                        ) {
                            <hr class="mt-2 mb-4" />
                            <div>
                                <h5
                                    class="mb-4 ms-2 mt-2"
                                    [attr.data-testid]="
                                        'formly-product-vendor-product-price-edit-vendor-relationships-list-h5'
                                    "
                                >
                                    {{ 'product.price-edit-oldprices' | translate }}
                                </h5>
                                <app-price-list-entry-list-widget
                                    #priceListEntryHistoryListWidget
                                    [product]="product()"
                                    [listType]="PriceListType.VENDOR"
                                    [creditorAddressId]="priceListLinkNodeSelectedSig()?.addressId"
                                    [priceList]="priceListLinkNodeSelectedSig()?.vendorPriceList"
                                    [onlyHistory]="true"
                                    [noCopy]="true"
                                    [noAddNew]="true"
                                    [noDelete]="true"
                                    [noBaseEdit]="true"
                                    [hasPriceReferenceProduct]="hasPurchasePriceReferenceProduct()"
                                    [dataTestId]="
                                        'formly-product-vendor-product-price-edit-vendor-relationships-list-price-list-entry-list-widget-2'
                                    "
                                />
                            </div>
                        }
                        <hr class="border-gray-200/20" />
                        <div class="!mx-1">
                            <app-vendor-product-edit-widget
                                [(partialDataModel)]="priceListLinkNodeSelectedSig"
                                [product]="product()"
                                [unit]="product()?.unit"
                                (vendorDetailsSaved)="onVendorDetailsSaved($event)"
                            />
                        </div>
                    </div>
                }
            </div>
        </ng-template>
    </p-splitter>
} @else {
    <p-skeleton height="12rem" styleClass="m-2" />
}

<p-dialog
    #chooseDialog
    [draggable]="true"
    [(visible)]="copyOrEditPriceListDialogVisible"
    [resizable]="true"
    modal="true"
    (close)="chooseDialog.closable = true"
    showCloseIcon="true"
    width="600px"
    [attr.data-testid]="
        'formly-product-vendor-product-price-edit-vendor-relationships-list-choose-dialog'
    "
>
    <app-address-drop-down
        #addressDropDown
        (valueChange)="setSelectedAddress($event)"
        [externalDataTestId]="true"
        [dataTestId]="
            'formly-product-vendor-product-price-edit-vendor-relationships-list-address-drop-down'
        "
    />
    <!-- WARNING msg to say to the user, that the selected address is already liked, exclude the link to create a new link -->
    @if (addressAlreadyLinked(selectedAddressSig())) {
        <div class="alert alert-warning mt-2">
            {{ 'products.vendor-pricelist-address-already-linked' | translate }}
        </div>
    }
    <!-- SAVE -->
    <p-button
        class="mt-2"
        (onClick)="copyOrSaveVendorPriceList()"
        [hidden]="addressAlreadyLinked(selectedAddressSig())"
        label="{{ 'common.save' | translate }}"
        [attr.data-testid]="
            'formly-product-vendor-product-price-edit-vendor-relationships-list-save-button'
        "
    >
    </p-button>
</p-dialog>
